import { FormattedMessage } from 'react-intl';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';

import { defineMessages, useIntl } from 'react-intl';
import SignUpForm from './SignUpForm';
import './Signup.scss';

const messages = defineMessages({
  portknoxSignup: {
    id: 'signup',
    defaultMessage: 'First steps with Portknox - Nextcloud Hosting',
  },
  seo_description: {
    id: 'SEO Description Signup',
    defaultMessage:
      'Create your cloud and test Portknox with no obligations - Nextcloud Hosting',
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
});
const SignupView = () => {
  const intl = useIntl();
  return (
    <div className="signup ui container">
      <Helmet
        title={intl.formatMessage(messages.portknoxSignup)}
        meta={[
          {
            name: 'description',
            content: intl.formatMessage(messages.seo_description),
          },
        ]}
      />
      <div className="wrapper">
        <div className="flex">
          <div className="item">
            <h2>
              <FormattedMessage
                id="signup_title"
                defaultMessage="Privacy for your digital life!"
              />
            </h2>
            <h3>
              <FormattedMessage
                id="signup_subtitle"
                defaultMessage="Try Portknox free for 14 days"
              />
            </h3>
            <p>
              <FormattedMessage
                id="signup_pitch"
                defaultMessage="Explore Nextcloud and your new digital home, without beeing watched or every step logged!"
              />
            </p>
            <p>
              <FormattedMessage
                id="signup_description"
                defaultMessage="No credit card. No spam. No commitment."
              />
            </p>
          </div>
          <div className="itemSecondary">
            <div className="card">
              <SignUpForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupView;
